import api from "../../http";

export default class ApiGamesText {
  static async getApiGamesText(url) {
    return api.get(url)
  }
}